exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{background-color:transparent}.overlay__background{z-index:5;position:fixed;top:0;left:0;width:100%;height:100%;background-color:#aaa;opacity:0.6}.overlay__container{max-height:80vh;overflow-y:auto;z-index:5;width:75%;position:fixed;left:50%;margin-left:-37.5%;top:15vh;background-color:#fff;height:auto;padding:10px;border-radius:20px}.overlay__container__close-button{float:right;margin:0.5rem;right:0.5rem;font-size:1.3rem;cursor:pointer}\n", ""]);

// exports
